import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { GroupOperation } from '@group/domain/GroupEntity/GroupOperation';
import { toast } from 'react-hot-toast';
import type { GroupId, UserId } from 'balus-common';
import type { GroupMemberRole } from '@group/domain';
import { BasicRoleSelect } from '../common';
type Props = {
  groupId: GroupId;
  userId: UserId;
  defaultRole: GroupMemberRole;
  disabled: boolean;
};

export const RoleSelect: React.FC<Props> = ({ groupId, userId, defaultRole, disabled }: Props) => {
  const { t } = useTranslation();
  const handleChange = useCallback(
    async (role: GroupMemberRole) => {
      try {
        await GroupOperation.updateMemberRole(groupId, userId, role);
        toast.success(t('group.members.roleSelect.success'));
      } catch (err) {
        toast.error(t('group.members.roleSelect.error'));
        console.error(err);
      }
    },
    [groupId, userId, t]
  );

  return <BasicRoleSelect defaultRole={defaultRole} onChange={handleChange} disabled={disabled} />;
};
